import React from 'react';
import {Link} from 'react-router-dom';
import {usePageMeta} from '../../seo/usePageMeta';

/** The 404 content without page meta, for pages that set their own (noindex) meta. */
export const NotFoundContent = () => (
    <div className="page page--narrow">
        <div className="card content-card">
            <h1 className="content-title">Seite nicht gefunden</h1>
            <p className="prose">
                Diese Seite gibt es leider nicht (mehr). Vielleicht findest du, was du suchst, über das Menü oder auf der Startseite.
            </p>
            <Link to="/" className="button content-actions">Zur Startseite</Link>
        </div>
    </div>
);

const NotFound = () => {
    usePageMeta({title: 'Seite nicht gefunden', noindex: true});
    return <NotFoundContent/>;
};

export default NotFound;
